import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-transparent border-b border-white/15 py-4 font-mono2 text-sm tracking-wider text-[#f5f3ef] placeholder:text-[#64646e] focus:outline-none focus:border-[#38bdf8]/80 transition-colors duration-500";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "sending", msg: "" });
    try {
      const res = await fetch(`${API}/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const detail = Array.isArray(data.detail) ? "Bitte gib eine gültige E-Mail-Adresse ein." : data.detail;
        throw new Error(detail || "Anmeldung gerade nicht möglich — versuch's später nochmal.");
      }
      setState({
        status: "sent",
        msg:
          data.state === "already"
            ? "DU BIST BEREITS DABEI — TONE MAIL KOMMT."
            : "FAST GESCHAFFT — CHECK DEIN POSTFACH UND BESTÄTIGE DEINE ANMELDUNG.",
      });
      setEmail("");
    } catch (err) {
      setState({ status: "error", msg: err.message });
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative py-28 md:py-40 px-6 md:px-16 border-t border-white/5 overflow-hidden">
      <div className="absolute -bottom-40 left-0 w-[500px] h-[500px] bg-[#38bdf8]/5 blur-[130px] rounded-full pointer-events-none" />
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-end">
        <div>
          <Reveal>
            <Eyebrow>NEWSLETTER</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display font-extrabold uppercase tracking-[-0.03em] leading-[0.9] text-[clamp(3rem,5.5vw,5.5rem)] text-[#f5f3ef] mt-6">
              TONE <span className="text-[#70c7fa]">ULTRAS</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 font-mono2 text-[11px] md:text-xs tracking-[0.3em] text-[#38bdf8] uppercase">
              Mehr Musik. Mehr Shows. Weiß als Erste:r Bescheid.
            </p>
            <p className="mt-5 text-sm md:text-base text-[#a3a3ac] font-light leading-relaxed max-w-md">
              Erhalte exklusive Updates zu neuer Musik, Releases, Shows und besonderen TONE-Momenten — direkt in
              dein Postfach.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.24}>
          <AnimatePresence mode="wait">
            {state.status === "sent" ? (
              <motion.div
                key="done"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                className="border border-[#38bdf8]/30 p-8"
              >
                <p data-testid="newsletter-success-msg" className="font-mono2 text-[11px] tracking-[0.25em] text-[#38bdf8] uppercase leading-relaxed">
                  {state.msg}
                </p>
                <p className="mt-3 text-xs text-[#64646e] font-light">Double-Opt-in: Ohne Bestätigung keine Mail.</p>
              </motion.div>
            ) : (
              <motion.form key="form" data-testid="newsletter-form" onSubmit={submit} exit={{ opacity: 0, y: -12 }}>
                <label htmlFor="newsletter-email" className="font-mono2 text-[10px] tracking-[0.35em] text-[#64646e] uppercase">
                  E-Mail-Adresse
                </label>
                <div className="mt-2 flex flex-col sm:flex-row sm:items-end gap-6">
                  <input
                    id="newsletter-email"
                    data-testid="newsletter-email-input"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="deine@email.de"
                    className={`${inputCls} sm:flex-1`}
                  />
                  <button
                    data-testid="newsletter-submit-btn"
                    type="submit"
                    disabled={state.status === "sending"}
                    className="shrink-0 px-10 py-4 bg-[#f5f3ef] text-[#070709] font-display font-bold tracking-wide text-sm hover:bg-[#70c7fa] hover:shadow-[0_0_36px_rgba(56,189,248,0.35)] disabled:opacity-50 transition-all duration-500"
                  >
                    {state.status === "sending" ? "…" : "TONE ULTRA WERDEN"}
                  </button>
                </div>
                {state.status === "error" && (
                  <p data-testid="newsletter-error-msg" className="mt-4 font-mono2 text-[11px] tracking-[0.2em] text-red-400 uppercase">
                    {state.msg}
                  </p>
                )}
                <p className="mt-6 text-xs text-[#64646e] font-light leading-relaxed">
                  Mit deiner Anmeldung stimmst du zu, gelegentlich Updates von TONE zu erhalten. Du kannst dich
                  jederzeit wieder abmelden.
                </p>
              </motion.form>
            )}
          </AnimatePresence>
        </Reveal>
      </div>
    </section>
  );
}
